import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Mail, MessageSquare, Gamepad2 } from "lucide-react";
import DashboardNav from "../components/DashboardNav";

function ContactPage() {
  const { currentUser } = useAuth();

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {currentUser ? (
        <DashboardNav />
      ) : (
        <nav className="fixed top-0 w-full z-50 bg-gray-950/80 backdrop-blur-xl border-b border-gray-800/50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <Link to="/" className="flex items-center gap-2">
                <Gamepad2 className="w-8 h-8 text-brand-400" />
                <span className="text-xl font-bold bg-gradient-to-r from-brand-400 to-purple-400 bg-clip-text text-transparent">
                  referred.games
                </span>
              </Link>
              <div className="flex items-center gap-3">
                <Link
                  to="/auth?mode=login"
                  className="text-sm text-gray-300 hover:text-white transition-colors px-4 py-2"
                >
                  Sign In
                </Link>
                <Link
                  to="/auth?mode=signup"
                  className="text-sm bg-brand-600 hover:bg-brand-500 text-white px-5 py-2 rounded-lg transition-colors font-medium"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </nav>
      )}

      <div className={`${currentUser ? "py-12" : "pt-32 pb-20"} px-4 sm:px-6 lg:px-8`}>
        <div className="max-w-2xl mx-auto">

          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-500/10 border border-brand-500/20 mb-6">
              <MessageSquare className="w-8 h-8 text-brand-400" />
            </div>
            <h1 className="text-4xl font-bold mb-4">Get in Touch</h1>
            <p className="text-gray-400 text-lg">
              Have a question, partnership inquiry, or need support? We'd love to hear from you.
            </p>
          </div>

          <div className="space-y-6">
            {/* General Contact */}
            <div className="bg-gray-900/50 border border-gray-800/50 rounded-2xl p-6">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-brand-500/10 border border-brand-500/20 flex-shrink-0">
                  <Mail className="w-5 h-5 text-brand-400" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-1">General Inquiries</h3>
                  <p className="text-sm text-gray-400 mb-3">
                    For general questions, partnerships, or anything else.
                  </p>
                  <a
                    href="mailto:info@referred.games"
                    className="text-brand-400 hover:text-brand-300 font-medium transition-colors"
                  >
                    info@referred.games
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-gray-500">
              We typically respond within 24 hours during business days.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
